(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const renderHeaderCountryFlags = (root = document) => {
    root.querySelectorAll('.header-country-flag[data-country-iso]').forEach((flag) => {
      const countryCode = flag.dataset.countryIso;

      if (!/^[A-Z]{2}$/i.test(countryCode)) return;

      flag.textContent = String.fromCodePoint(
        ...Array.from(countryCode.toUpperCase(), (character) => character.charCodeAt(0) + 127397)
      );
    });
  };

  renderHeaderCountryFlags();
  document.addEventListener('shopify:section:load', (event) => renderHeaderCountryFlags(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-carousel-pro')) {
    customElements.define(
      'image-carousel-pro',
      class ImageCarouselPro extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.sliderComponent = this.querySelector('slider-component');
          this.track = this.querySelector('[id^="Slider-"]');
          this.dotButtons = Array.from(this.querySelectorAll('.image-carousel-pro__dot'));
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.autoRotate = this.dataset.autoplay === 'true';
          this.autoRotateInterval = Number(this.dataset.autoplayInterval) * 1000;
          this.userInteracted = false;

          if (!this.sliderComponent || !this.track) return;

          this.onSlideChanged = this.updateDots.bind(this);
          this.onDotClick = this.handleDotClick.bind(this);
          this.onCardClick = this.handleCardClick.bind(this);
          this.onUserInteraction = this.stopForUserInteraction.bind(this);
          this.onVisibilityChange = this.handleVisibilityChange.bind(this);
          this.onMotionChange = this.handleMotionChange.bind(this);

          this.sliderComponent.addEventListener('slideChanged', this.onSlideChanged);
          this.dotButtons.forEach((button) => button.addEventListener('click', this.onDotClick));
          this.track.addEventListener('click', this.onCardClick);
          this.addEventListener('pointerdown', this.onUserInteraction, { passive: true });
          this.addEventListener('wheel', this.onUserInteraction, { passive: true });
          this.addEventListener('keydown', this.onUserInteraction);
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          this.reducedMotion.addEventListener('change', this.onMotionChange);

          requestAnimationFrame(() => {
            this.updateDots();
            this.startAutoplay();
          });
        }

        disconnectedCallback() {
          this.stopAutoplay();

          if (this.sliderComponent) {
            this.sliderComponent.removeEventListener('slideChanged', this.onSlideChanged);
          }

          this.dotButtons?.forEach((button) => button.removeEventListener('click', this.onDotClick));
          this.track?.removeEventListener('click', this.onCardClick);
          this.removeEventListener('pointerdown', this.onUserInteraction);
          this.removeEventListener('wheel', this.onUserInteraction);
          this.removeEventListener('keydown', this.onUserInteraction);
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
          this.reducedMotion?.removeEventListener('change', this.onMotionChange);
          this.initialized = false;
        }

        updateDots() {
          const totalPages = this.sliderComponent.totalPages || 1;
          const currentPage = Math.min(this.sliderComponent.currentPage || 1, totalPages);

          this.dotButtons.forEach((button, index) => {
            const isVisible = index < totalPages;
            const isCurrent = index === currentPage - 1;
            button.hidden = !isVisible;
            button.setAttribute('aria-current', isCurrent ? 'true' : 'false');
          });
        }

        handleDotClick(event) {
          const index = Number(event.currentTarget.dataset.slideIndex);
          const totalPages = this.sliderComponent.totalPages || 1;

          this.stopForUserInteraction();
          if (index >= totalPages || !this.sliderComponent.sliderItemOffset) return;

          this.sliderComponent.setSlidePosition(index * this.sliderComponent.sliderItemOffset);
        }

        handleCardClick(event) {
          const card = event.target.closest('.image-carousel-pro__card');
          const slide = card?.closest('.image-carousel-pro__slide');

          if (!slide || !this.track.contains(slide) || this.isSlideFullyVisible(slide)) return;

          event.preventDefault();
          this.stopForUserInteraction();

          const maximumScrollLeft = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const targetPosition = Math.min(Math.max(slide.offsetLeft, 0), maximumScrollLeft);

          this.sliderComponent.setSlidePosition(targetPosition);
        }

        isSlideFullyVisible(slide) {
          const viewport = this.track.getBoundingClientRect();
          const slideBounds = slide.getBoundingClientRect();
          const tolerance = 1;

          return (
            slideBounds.left >= viewport.left - tolerance && slideBounds.right <= viewport.right + tolerance
          );
        }

        stopForUserInteraction() {
          this.userInteracted = true;
          this.stopAutoplay();
        }

        handleVisibilityChange() {
          if (document.hidden) {
            this.stopAutoplay();
          } else if (!this.userInteracted) {
            this.startAutoplay();
          }
        }

        handleMotionChange() {
          if (this.reducedMotion.matches) {
            this.stopAutoplay();
          } else if (!this.userInteracted) {
            this.startAutoplay();
          }
        }

        startAutoplay() {
          if (
            !this.autoRotate ||
            this.userInteracted ||
            document.hidden ||
            this.reducedMotion.matches ||
            !this.sliderComponent.sliderItemOffset ||
            this.sliderComponent.currentPage >= this.sliderComponent.totalPages
          ) {
            return;
          }

          this.stopAutoplay();
          this.autoplayTimer = window.setTimeout(() => this.advanceAutoplay(), this.autoRotateInterval);
        }

        advanceAutoplay() {
          const totalPages = this.sliderComponent.totalPages || 1;
          const currentPage = this.sliderComponent.currentPage || 1;

          if (document.hidden || this.reducedMotion.matches || currentPage >= totalPages) {
            this.stopAutoplay();
            return;
          }

          this.sliderComponent.setSlidePosition(
            this.sliderComponent.slider.scrollLeft + this.sliderComponent.sliderItemOffset
          );
          this.autoplayTimer = window.setTimeout(() => this.advanceAutoplay(), this.autoRotateInterval);
        }

        stopAutoplay() {
          if (this.autoplayTimer) {
            window.clearTimeout(this.autoplayTimer);
            this.autoplayTimer = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
